import Utils from "./utils";
import $ from 'jquery';
import 'slick-carousel';
import Sketch from '../vendors/glTransition/sketch'


class HomeImageTransition {

	/**
	 * @param options
	 */
	constructor() {

		// on construit que si nécessaire
		if($('.presentationTitle').length === 0){
			return false;
		}

		//console.debug('HomeImageTransition::contructor');

		var tempTab = []
		pagedatas.items.forEach(element => tempTab.push(element.img));

		this.tlAnimation = gsap.timeline();
		this.items = pagedatas.items;
		this.$title = $('.presentationTitle h1');
		this.$subTitle = $('.presentationSubTitle');
		this.$paginations = $('.presentation__pagination');
		this.$button = $('.presentationBtnVideo');
		this.counter = 0;
		this.initContent();
		this.initPagination();

		this.tl = gsap.timeline({
			repeat: -1,
			paused: true
		})
		this.tl.add(() => {this.next()}, 10);

		var self = this;
		$('.presentation__pagination li').on('click', function () {
			self.counter = $( this ).index();
			self.nextSlide();
			self.tl.restart();
		})

		$('#app').on('click','.btnVideoPlayer',function () {
			//console.debug('pause')
			self.tl.kill();
		})

		$('#app').on('click','.videoPopin__close', function () {
			//console.debug('play')
			self.tl.restart();
		})



		$('#app').on('sketch::ready', () => {
			this.tl.play();
		});

		$('#app').on('sketch::pause', () => {
			//console.log('sketch::pause');
			this.tl.pause();
		});

		this.sketch = new Sketch({
			img: tempTab,
			debug: false,
			uniforms: {
				intensity: {value: 0.3, type:'f', min:0., max:2},
			},
			fragment: `
		uniform float time;
		uniform float progress;
		uniform float width;
		uniform float scaleX;
		uniform float scaleY;
		uniform float transition;
		uniform float radius;
		uniform float intensity;
		uniform sampler2D texture1;
		uniform sampler2D texture2;
		uniform sampler2D displacement;
		uniform vec4 resolution;
		varying vec2 vUv;

		void main()	{
		  vec2 newUV = (vUv - vec2(0.5))*resolution.zw + vec2(0.5);

         vec4 d1 = texture2D(texture1, newUV);
         vec4 d2 = texture2D(texture2, newUV);

         float displace1 = (d1.r + d1.g + d1.b)*0.33;
         float displace2 = (d2.r + d2.g + d2.b)*0.33;

         vec4 t1 = texture2D(texture1, vec2(newUV.x, newUV.y + progress * (displace2 * intensity)));
         vec4 t2 = texture2D(texture2, vec2(newUV.x, newUV.y + (1.0 - progress) * (displace1 * intensity)));

         gl_FragColor = mix(t1, t2, progress);

		}

	`
		});

	}

	initContent() {
		this.$title.html(this.items[this.counter].title);
		this.$subTitle.html(this.items[this.counter].subTitle);
		this.initButton();
	}


	initPagination(){
		for(let i=0; i < this.items.length; i++){
			this.$paginations.append('<li>');
		}
		this.$paginations.find('li:first-child').addClass('active');
	}

	initButton() {

		this.$button.removeAttr('href');
		this.$button.removeAttr('urlVideo');
		this.$button.removeClass('btnVideoPlayer');

		if(this.items[this.counter].buttonType === "Url"){
			this.$button.show();
			this.$button.find('span').html(this.items[this.counter].labelButton);
			this.$button.attr('href', this.items[this.counter].url);

		} else if(this.items[this.counter].buttonType === "Video") {
			this.$button.show();
			this.$button.find('span').html(this.items[this.counter].labelButton);
			this.$button.attr('urlVideo', this.items[this.counter].urlVideo);
			this.$button.addClass('btnVideoPlayer')
		} else {
			this.$button.hide();

		}
	}

	next(){
		if(this.counter >= this.items.length -1) {
			this.counter = 0;
		} else {
			this.counter++;
		}

		this.nextSlide();
	}

	prev(){
		if(this.counter < 1) {
			this.counter = this.items.length - 1;
		} else {
			this.counter--;
		}
		this.nextSlide();
	}


	nextSlide() {

		this.$paginations.find('li').eq(this.counter).addClass('active').siblings().removeClass('active');
		this.animNextSlideWithTxt();


		//gsap.to('.occ-slider__hover', 0.5, {x: 50, autoAlpha: 0});
	}


	animNextSlideWithTxt(){

		//console.debug('Slider :: animNextSlideWithTxt');

		this.tlAnimation.clear();

		this.tlAnimation.add([
			gsap.to(this.$title, 1.25, {yPercent: 200, ease: 'Expo.easeInOut'}),
			gsap.to(this.$subTitle, 1.25, {yPercent: 200, ease: 'Expo.easeInOut'}),
			gsap.to(this.$button, 1, {yPercent: 150, ease: 'Expo.easeInOut'}),
		]);

		this.tlAnimation.add( () => {
			this.initContent();
			this.sketch.next(this.counter)
		});

		this.tlAnimation.add([
			gsap.to(this.$title, 1.25, {yPercent: 0, x:0, ease: 'Expo.easeInOut'}),
			gsap.to(this.$subTitle, 1.25, {yPercent: 0, ease: 'Expo.easeInOut', delay: .2}),
			gsap.to(this.$button, 1, {yPercent: 0, ease: 'Expo.easeInOut', delay: .3})
		]);

	}

	destroy() {
		//console.debug('Slider :: destroy');
		if(typeof this.sketch != 'undefined'){
			this.sketch.destroy();
			this.tlAnimation.kill();
			this.tl.kill();
		}
	}




}

module.exports = HomeImageTransition;
